import { render } from "./OrgProfileView.vue?vue&type=template&id=0d424fc5"
import script from "./OrgProfileView.vue?vue&type=script&lang=js"
export * from "./OrgProfileView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__